import { render, staticRenderFns } from "./Observer.vue?vue&type=template&id=ba656c6c&scoped=true&"
import script from "./Observer.vue?vue&type=script&lang=js&"
export * from "./Observer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba656c6c",
  null
  
)

export default component.exports